<script setup lang="ts">
import { computed } from "vue";

import { useTheme } from "@/layout/composables/theme";

const { isDark } = useTheme();

const color = computed(() => (isDark.value ? "white" : "black"));
</script>

<template>
  <svg width="17" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172.47 172">
    <path
      :fill="color"
      class="cls-1"
      d="m40.24,68.5c2.83-3,5.67-6,8.5-9,9.5-9.33,19-18.67,28.5-28,.83-1,1.67-2,2.5-3,2.83-2.67,5.67-5.33,8.5-8,1.79-1.79,3.26-4.2,5.5-5.5-.55-2.08-2.2-2.7-3.5-4-2.5-2.5-5-5-7.5-7.5-1.29-1.29-1.92-2.96-4-3.5-19.5,19.66-39,39.34-58.5,59-4.17,4.17-8.33,8.33-12.5,12.5-1.33,1.17-2.67,2.33-4,3.5v1c-.33.17-.67.33-1,.5v1c-.33.17-.67.33-1,.5v1h-.5v1.5h-.5v1.5H.24c-.57,1.8.01,8.36.5,9.5h.5c.17.67.33,1.33.5,2h.5v1c.33.17.67.33,1,.5v1c1.67,1.5,3.33,3,5,4.5,1.5,1.67,3,3.33,4.5,5,22.16,22,44.34,44,66.5,66,.43.56-.07.08.5.5,1.61-2.78,5.68-5.68,8-8,1.93-1.93,3.58-4.61,6-6-.73-2.69-3.74-4.24-5.5-6l-13.5-13.5c-16.83-17-33.67-34-50.5-51v-3.5c5.33-5.17,10.67-10.33,16-15.5Zm132,13.5c-1.99-6.32-6.84-9.84-11-14-1.67-1.83-3.33-3.67-5-5.5-5-4.83-10-9.67-15-14.5-2.83-2.83-5.67-5.67-8.5-8.5-1.34-1.34-2.3-3.02-4-4-3.33,3.5-6.67,7-10,10.5-1.33,1.17-2.67,2.33-4,3.5-.39,1.34,1.46,1.95,2,2.5,1.99,2.02,3.99,3.99,6,6,4.17,4.33,8.33,8.67,12.5,13,2.67,2.5,5.33,5,8,7.5,1,1.17,2,2.33,3,3.5.5.33,1,.67,1.5,1,.58.84,0,1.14,1,2-.23,4.25-5.55,7.55-8,10l-18,18c-2.31,2.31-5.22,6.4-8,8,.42,3.09,2.32,2.87,4,4.5,3.33,3.5,6.67,7,10,10.5,2.08-.56,2.7-2.2,4-3.5,2.5-2.5,5-5,7.5-7.5l20-20c2.5-2.33,5-4.67,7.5-7v-1c.67-.5,1.33-1,2-1.5v-1h.5c.33-1,.67-2,1-3h.5c.49-1.14,1.07-7.7.5-9.5Z"
    />
  </svg>
</template>
